import React, { useEffect, useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import useVerifyEmailWithTargetUrl from '@/services/api/auth/useVerifyEmailWithTargetUrl'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import useResendVerificationEmailNotification from '@/services/api/auth/useResendVerificationEmailNotification'
import { Button } from '@/components/ui/button'

function ResendVerificationEmail() {
  const { resend, resendStatus } = useResendVerificationEmailNotification()

  useEffect(() => {
    resend({ email: undefined })
  }, [])
  return (
    <div className="pf-auth grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>
            {resendStatus.status === 'success'
              ? 'Verification Email Sent'
              : 'Resending Verification Email'}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-txt-secondary">
          {resendStatus.status === 'success' ? (
            <div>
              <p>
                We have successfully sent a new verification email to your
                registered email address.
              </p>
              <p>
                Please check your inbox and spam/junk folder. Follow the link in
                the email to verify your account.
              </p>
            </div>
          ) : (
            <div>
              <p>Please wait while we send you a new verification email.</p>
              <p>
                Make sure to check your spam or junk folder. If you do not
                receive the email shortly, try again later.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default function VerifyEmailWithTargetUrl({
  target,
}: {
  target: string
}) {
  const { action, status } = useVerifyEmailWithTargetUrl({ target })
  const [showResend, setShowResend] = useState(false)
  const [searchParams] = useSearchParams()
  const login = searchParams.get('login')
  const navigate = useNavigate()
  const redirectTimeInSeconds = 3

  useEffect(() => {
    if (target) {
      action()
    }
  }, [target])

  useEffect(() => {
    if (status.status === 'success') {
      setTimeout(() => {
        navigate('/')
      }, redirectTimeInSeconds * 1000)
    }
  }, [status.status])

  if (showResend) {
    return <ResendVerificationEmail />
  }

  return (
    <div className="pf-auth grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>
            {status.status === 'error'
              ? 'Verification Failed'
              : status.status === 'success'
                ? 'Email Verified Successfully'
                : 'Verifying Your Email'}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-txt-secondary">
          {status.status === 'pending' && 'Please wait....'}
          {status.status === 'success' && (
            <div>
              <p>Your email address has been verified.</p>
              <p>You can now proceed to use your account.</p>
              <p>Redirecting to your account</p>
            </div>
          )}
          {(status.status === 'error' || login === 'success') && (
            <div className="text-balance text-justify">
              <p>We could not verify your email address.</p>
              <p>
                If you are logged in with another account, please{' '}
                <Link to="/logout">log out</Link> and click the link from your
                email.
              </p>
              <p>
                Or
                <Button
                  type="button"
                  variant="link"
                  onClick={() => setShowResend(true)}
                >
                  click here
                </Button>
                to request a new verification email.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
